import { render, staticRenderFns } from "./RobotsTxt.vue?vue&type=template&id=b3c44bfa&"
import script from "./RobotsTxt.vue?vue&type=script&lang=ts&"
export * from "./RobotsTxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports